import { Controller } from "@hotwired/stimulus";

export default class AutoScrollController extends Controller {
  static values = {
    target: String
  };

  connect() {
    setTimeout(() => {
      this.scrollToTarget();
    }, 200);
  }

  scrollToTarget() {
    const target = document.getElementById(this.targetValue);

    if (!target) return;

    const scrollContainer = target.closest("#scroll_modal_content");
    if (!scrollContainer) return;

    const containerRect = scrollContainer.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    const scrollTop = scrollContainer.scrollTop + (targetRect.top - containerRect.top);

    scrollContainer.scrollTo({
      top: scrollTop,
      behavior: "smooth"
    });
  }
}
